export {default as DatePicker} from './DatePicker.vue'

export function isDatePickerType(type) {
  return type === 'datetime' || type === 'date' || type === 'month' || type === 'year'
}
